import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiAppTopMessageComponent } from './top-message.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiAppTopMessageComponent,
    ],
    exports: [
        EuiAppTopMessageComponent,
    ],
})
export class EuiAppTopMessageModule { }
